import {Component, InjectionToken, Signal, Type, WritableSignal} from '@angular/core';
import {SearchFilterMap, SearchIndexName} from '@models/search';

@Component({
  template: '',
  standalone: true,
  selector: 'app-filter-me-component',
})
export abstract class MeComponent {}

export enum FilterVisibility {
  EVERYONE,
  ONLY_AUTHED_USERS,
  ONLY_ADMIN_USERS,
  NOONE,
}

export interface FilterSelection {
  label: string;
  value: string;
}

export interface Filter<I extends SearchIndexName> {
  key: string;
  label: string;
  component: Type<any>;
  selectedValues: WritableSignal<string[]>;
  selected: Signal<FilterSelection[]>;
  defaultExpanded?: boolean;
  load(values: string[]): void;

  /** Mutates the given SearchFilterMap object in place with the current Filter object's selectedValues */
  apply(filterBody: SearchFilterMap[I]): void;

  remove(value: string): void;
  showCategoryButton?: boolean;
  visibility: FilterVisibility;
}

export const FILTERS_TOKEN = new InjectionToken<Type<Filter<SearchIndexName>>[]>('search filter list');
export const FILTERS_ME_TOKEN = new InjectionToken<Type<MeComponent>>('me component for filters');
